module.exports = __webpack_public_path__ + "img/time_square.b8541acd.svg";